/**
 * Painel do jogador do Cabal Next (dono, 2026-10-17): sai o layout do Liberty (sidebar antiga, liberty.css); fica o
 * header do site (menu Inicio/Noticias/Painel + nome do jogador) e um menu lateral no tema do Next:
 * Minha Conta (/account) | Personagens (/account/personagens) | Guilds (/account/guilds, 2026-10-22) |
 * Suporte (/account/suporte) | Painel GM (/admin, so' GM).
 * As paginas reaproveitam as chamadas de API do painel antigo (as telas antigas continuam no projeto).
 * CSS em dashboard.css (prefixo nxd-, dentro da raiz .nx do site).
 */
import { useEffect } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Flag, Headset, ShieldCheck, UserRound, Users } from 'lucide-react';
import { useAuth } from '@/shared/contexts/AuthContext';
import { NextFooter, NextHeader, useScrollTopOnMount } from '@/features/Home/next/NextLayout';
import './dashboard.css';

const MENU = [
  { to: '/account', label: 'Minha Conta', icon: UserRound, end: true },
  { to: '/account/personagens', label: 'Personagens', icon: Users, end: false },
  { to: '/account/guilds', label: 'Guilds', icon: Flag, end: false },
  { to: '/account/suporte', label: 'Suporte', icon: Headset, end: false },
];

export default function NextDashboardLayout() {
  // isGm = /auth/gm-info (cabal_gm_access), o mesmo que o painel GM confere no GmGate
  const { isLoggedIn, isGm } = useAuth();
  const navigate = useNavigate();
  useScrollTopOnMount();

  useEffect(() => {
    if (!isLoggedIn) navigate('/', { replace: true });
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    const prev = document.title;
    document.title = 'Painel · Cabal Next';
    return () => {
      document.title = prev;
    };
  }, []);

  if (!isLoggedIn) return null;

  return (
    <div className="nx nxd-page">
      <NextHeader active="painel" />
      <main className="nxd">
        <div className="nx-container nxd__inner">
          <aside className="nxd-side">
            <p className="nxd-side__title">Painel</p>
            <nav className="nxd-side__nav">
              {MENU.map(({ to, label, icon: Icon, end }) => (
                <NavLink key={to} to={to} end={end} className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                  <Icon size={18} />
                  <span>{label}</span>
                </NavLink>
              ))}
              {/* conta GM (dono 2026-10-17): UNICA entrada do painel GM -- mesma sessao do site, /admin abre ja' logado */}
              {isGm && (
                <Link to="/admin" className="nxd-side__gm">
                  <ShieldCheck size={18} />
                  <span>Painel GM</span>
                </Link>
              )}
            </nav>
          </aside>
          <section className="nxd-content">
            <Outlet />
          </section>
        </div>
      </main>
      <NextFooter />
    </div>
  );
}
